<template class="">
    <div id="furtherDetailsBlockElement" class="col-sm-12 col-md-8 prod-furtherdetails">
        <div id="detailPanelBlockElement" class="panel-group">
            <div id="headlineOfRelated" v-html="detailsHeadline"></div>
            <template v-if="feature">
                <feature-matrix-table
                    :tabs="tabs"
                    :rows="rows"
                    :lang="lang"
                ></feature-matrix-table>
            </template>
            <template v-else>
                <div id="detailImage" v-if="detailsimage.url && detailsMobileImage.url">
                    <picture>
                        <source media="((max-width: 767px) and ((-webkit-min-device-pixel-ratio: 2))"
                                :srcset="detailsMobileImage.url">
                        <source media="((min-width: 768px) and ((-webkit-min-device-pixel-ratio: 2))"
                                :srcset="detailsimage.url">
                        <source media="(max-width: 767px)"
                                :srcset="detailsMobileImage.url">
                        <source media="(min-width: 768px)"
                                :srcset="detailsimage.url">
                        <img :src="detailsimage.url" :alt="detailsimage.alt" class="lazy">
                    </picture>
                </div>
                <div v-else-if="detailsimage.url">
                    <img :src="detailsimage.url" :alt="detailsimage.alt" class="lazy">
                </div>
            </template>
            <v-collapse-wrapper class="panel panel-default" v-for="(detail, index) in details" v-bind:data="detail"
                                v-bind:key="detail.detail" :name="detail.detail" :class="`item-${index + 1}`">
                <div class="panel-heading" @click="switchIcon">
                    <span class="panel-title">
                        <a href="#details" class="prodinfos" v-collapse-toggle>
                            <h3 class="no-margin">
                                {{detail.detail}}
                                <i class="glyphicon glyphicon-plus"></i>
                            </h3>
                        </a>
                    </span>
                </div>
                <div class="panel-collapse" v-collapse-content>
                    <div class="panel-body"><span v-html="detail.description"></span></div>
                </div>
            </v-collapse-wrapper>

            <v-collapse-wrapper class="panel panel-default" v-if="product.avb || product.ipid || product.legalNotes || product.personalDataNotes || product.cancellationPolicy">
                <div class="panel-heading proddocshead" @click="switchIcon">
                    <span class="panel-title">
                        <a href="#details" class="proddocs" v-collapse-toggle>
                            <h3 class="no-margin">
                                {{ lang.documents_and_informations }}
                                <i class="glyphicon glyphicon-plus"></i>
                            </h3>
                        </a>
                    </span>
                </div>

                <div class="panel-collapse" v-collapse-content>
                    <div class="panel-body">
                        <ul class="list-unstyled">
                            <li v-if="product.avb">
                                <a :href="product.avb" target="_blank">
                                    <i class="glyphicon glyphicon-file"></i>
                                    {{ lang.avb }}
                                </a>
                            </li>
                            <li v-if="product.ipid">
                                <a :href="product.ipid" target="_blank">
                                    <i class="glyphicon glyphicon-file"></i>
                                    {{ lang.ipid }}
                                </a>
                            </li>
                            <li v-if="product.legalNotes">
                                <a :href="product.legalNotes" target="_blank">
                                    <i class="glyphicon glyphicon-file"></i>
                                    {{ lang.legal_notes }}
                                </a>
                            </li>
                            <li v-if="product.personalDataNotes">
                                <a :href="product.personalDataNotes" target="_blank">
                                    <i class="glyphicon glyphicon-file"></i>
                                    {{ lang.personal_data_notes }}
                                </a>
                            </li>
                            <li v-if="product.cancellationPolicy">
                                <a :href="product.cancellationPolicy" target="_blank">
                                    <i class="glyphicon glyphicon-file"></i>
                                    {{ lang.cancellation_policy }}
                                </a>
                            </li>
                        </ul>

                            <div id="bundleDocuments">
                                <ul class="list-unstyled document-bundle-list">
                                    <li v-if="filteredBundleDocuments.avb" class="bundle-document-space ">
                                        <a :href="filteredBundleDocuments.avb" target="_blank">
                                            <i class="glyphicon glyphicon-file"></i>
                                            {{ lang.avb }}
                                        </a>
                                    </li>
                                    <li v-if="filteredBundleDocuments.ipid">
                                        <a :href="filteredBundleDocuments.ipid" target="_blank">
                                            <i class="glyphicon glyphicon-file"></i>
                                            {{ lang.ipid }}
                                        </a>
                                    </li>
                                    <li v-if="filteredBundleDocuments.legalNotes">
                                        <a :href="filteredBundleDocuments.legalNotes" target="_blank">
                                            <i class="glyphicon glyphicon-file"></i>
                                            {{ lang.legal_notes }}
                                        </a>
                                    </li>
                                    <li v-if="filteredBundleDocuments.personalDataNotes">
                                        <a :href="filteredBundleDocuments.personalDataNotes" target="_blank">
                                            <i class="glyphicon glyphicon-file"></i>
                                            {{ lang.personal_data_notes }}
                                        </a>
                                    </li>
                                    <li v-if="filteredBundleDocuments.cancellationPolicy">
                                        <a :href="filteredBundleDocuments.cancellationPolicy" target="_blank">
                                            <i class="glyphicon glyphicon-file"></i>
                                            {{ lang.cancellation_policy }}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                    </div>
                </div>
            </v-collapse-wrapper>
        </div>

        <hr class="divider">

        <div id="brieflyexplained" class="panel-group">
            <div v-html="benefitsHeadline"></div>
            <v-collapse-wrapper class="panel panel-default" v-for="benefit in benefits" v-bind:data="benefit"
                                v-bind:key="benefit.benefit" :name="benefit.benefit">
                <div class="panel-heading" @click="switchIcon">
                    <span class="panel-title">
                        <a href="#benefits" class="prodbenefits" v-collapse-toggle>
                            <h3 class="no-margin">
                                {{benefit.benefit}}
                                <i class="glyphicon glyphicon-plus"></i>
                            </h3>
                        </a>
                    </span>
                </div>

                <div class="panel-collapse" v-collapse-content>
                    <div class="panel-body"><span v-html="benefit.description"></span></div>
                </div>
            </v-collapse-wrapper>
        </div>

        <hr class="divider">

    </div>
</template>

<script>
    import Helper from '../helper'
    import FeatureMatrixTable from "./FeatureMatrixTable.vue";
    export default {
        name: "product-benefits",
        props: ['insuranceBenefits', 'insuranceDetails', 'product', 'lang', 'bundleDocuments', 'feature'],
        components: {FeatureMatrixTable},
        data: function () {
            if (!this.feature || !this.feature.non_repeat ||  !this.feature.non_repeat.feature_matrix_data) {
                return {
                    currentItem: null,
                    tabs: [],
                    rows: [],
                }
            }
            const {matrix_column_tabs, slices} = this.feature.non_repeat.feature_matrix_data;
            return {
                currentItem: null,
                tabs: matrix_column_tabs,
                rows: slices,
            }
        },
        computed: {
            benefits: function () {
                return this.insuranceBenefits.benefits;
            },
            benefitsHeadline: function () {
                return this.insuranceBenefits.headline;
            },
            details: function () {
                return this.insuranceDetails.details;
            },
            detailsHeadline: function () {
                return this.insuranceDetails.headline;
            },
            detailsimage: function () {
                return this.insuranceDetails.detailsImage;
            },
            detailsMobileImage: function () {
                return this.insuranceDetails.detailsMobileImage;
            },
            filteredBundleDocuments: function () {
            const document = {
              avb: null,
              cancellation_policy: null,
              ipid: null,
              legal_notices: null,
              personal_data_collection_notices: null
            }
            if (this.bundleDocuments) {
                if (Helper.getOriginalFilename(this.bundleDocuments.avb) !== Helper.getOriginalFilename(this.product.avb)) {
                    document.avb = this.bundleDocuments.avb
                }
                if (Helper.getOriginalFilename(this.bundleDocuments.cancellation_policy) !== Helper.getOriginalFilename(this.product.cancellation_policy)) {
                    document.cancellation_policy = this.bundleDocuments.cancellation_policy
                }
                if (Helper.getOriginalFilename(this.bundleDocuments.ipid) !== Helper.getOriginalFilename(this.product.ipid)) {
                    document.ipid = this.bundleDocuments.ipid
                }
                if (Helper.getOriginalFilename(this.bundleDocuments.legal_notices) !== Helper.getOriginalFilename(this.product.legal_notices)) {
                    document.legal_notices = this.bundleDocuments.legal_notices
                }
                if (Helper.getOriginalFilename(this.bundleDocuments.personal_data_collection_notices) !== Helper.getOriginalFilename(this.product.personal_data_collection_notices)) {
                    document.personal_data_collection_notices = this.bundleDocuments.personal_data_collection_notices
                }
            }
            return document;
          }
        },
        methods: {
            switchIcon: function (e) {
                let icon = e.target;
                if (icon.className.indexOf('v-collapse-toggler') !== -1) {
                    icon = icon.children.item(0);
                }
                if (icon.children.length > 0) {
                    icon = icon.children.item(0);
                }
                let curClass = icon.getAttribute("class");
                switch (curClass) {
                    case "glyphicon glyphicon-plus":
                        if (this.currentItem !== null) {
                            this.currentItem.setAttribute("class", "glyphicon glyphicon-plus");
                        }
                        icon.setAttribute("class", "glyphicon glyphicon-minus");
                        this.currentItem = icon;
                        break;
                    case "glyphicon glyphicon-minus":
                        icon.setAttribute("class", "glyphicon glyphicon-plus");
                        this.currentItem = icon;
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    .panel-group .panel {
        margin-bottom: 0;
        border-radius: 0;
    }

    .panel-title h3 {
        font-weight: 400;
    }
</style>
